<template>
    <p v-if="noResults && !search && recentSearches.length === 0">
        {{ $t('nothing_found') }}
    </p>
    <div
        v-if="!search && recentSearches.length > 0"
        class="mb-2"
    >
        <div class="flex h-auto w-full flex-col items-start justify-start">
            <p class="font-semibold text-black">Recent Searches</p>
            <router-link
                v-for="recentSearch in recentSearches"
                :key="recentSearch.title"
                :to="getUrlForRecentSearch(recentSearch)"
                class="text-blue-500 hover:text-blue-600"
            >
                <fa
                    icon="link"
                    class="mr-2 text-sm"
                ></fa
                >{{ recentSearch[recentSearch.entryPropertyToShow] }}
            </router-link>
        </div>
    </div>
    <SearchResultsDropdownEntry
        v-for="searchType in SEARCH_TYPES"
        :key="searchType.title"
        :title="searchType.title"
        :entries="results[searchType.title]"
        :count="results[searchType.countKey]"
        :limit="entityResultsLimit"
        :path="searchType.path"
        :entry-property-in-path="searchType.entryPropertyInPath"
        :entry-property-to-show="searchType.entryPropertyToShow"
        :list-filter-name="searchType.listFilterName"
        :search="search"
    />
</template>

<script setup lang="ts">
import SearchResultsDropdownEntry from '@src/partials/header/SearchResultsDropdownEntry.vue'
import { RecentSearchEntry } from '@src/types/GlobalSearch'
import { useSearch } from '@stores/search'
import { storeToRefs } from 'pinia'

const searchStore = useSearch()

const {
    search,
    results,
    noResults,
    entityResultsLimit,
    SEARCH_TYPES,
    recentSearches,
} = storeToRefs(searchStore)

const getUrlForRecentSearch = (recentSearch: RecentSearchEntry) => {
    switch (recentSearch.path) {
        case '/accounts':
            return `/${
                recentSearch.account_type === 'natural'
                    ? 'naturalProfile'
                    : 'legalProfile'
            }/${
                recentSearch.account_type === 'natural'
                    ? recentSearch.natural_profile_uid
                    : recentSearch.legal_profile_uid
            }`
        case '/emails':
            return `${recentSearch.path}/${
                recentSearch[recentSearch.entryPropertyInPath]
            }?${recentSearch.listFilterName}=${recentSearch.id}`
        default:
            return `${recentSearch.path}/${
                recentSearch[recentSearch.entryPropertyInPath]
            }`
    }
}
</script>

<style scoped></style>
